import common from "./client/common.json"
import orders from "./client/orders.json"
import receptionPlaces from "./client/receptionPlaces.json";
import users from "./client/users.json";
import profile from "./client/profile.json";
import pricelist from "./client/pricelist.json";
import admin from "./admin";
import { LanguageTranslations } from "../abstract"

const lt: LanguageTranslations = {
    common,
    orders,
    receptionPlaces,
    users,
    profile,
    pricelist,
    admin
};

export default lt;

